import { SelectHTMLAttributes, ReactNode } from "react";
import './Select.scss'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
	icon?: string;
	variant?: string;
	children: ReactNode;
}

export function Select({variant, icon, children, ...rest}: SelectProps) {
	return(
		<div className="align-items-center d-flex">
			{icon && <span className="material-icons select-icon">{icon}</span>}
			<select className={`select ${variant ? variant : ''}`} {...rest}>
				{children}
			</select>
		</div>
	)
}
